import React from 'react'
import AppContent from './ui/partials/AppContent'

const AppLayout = ({ children }: { children: React.ReactNode }) => {
  return <AppContent>{children}</AppContent>
}

export default AppLayout
